import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { faPencilAlt, faTimes } from "@fortawesome/pro-solid-svg-icons";
import { faFloppyDisk } from "@fortawesome/pro-solid-svg-icons";
import { TextInput } from "~/components/TextInput";
import { cn } from "~/lib/utils";

// // // //

export function NameInput(props: {
    name: string;
    loading: boolean;
    onChange: (updatedName: string) => void;
}) {
    const { name, onChange, loading } = props;
    const [editing, setEditing] = useState(false);
    const [updatedName, setUpdatedName] = useState(name);
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        setEditing(false);
        setUpdatedName(name);
    }, [name]);

    useEffect(() => {
        if (loading === false) {
            setEditing(false);
            setUpdatedName(name);
        }
    }, [loading]);

    useEffect(() => {
        if (editing && inputRef.current) {
            inputRef.current?.focus();
        } else {
            setUpdatedName(name);
        }
    }, [editing]);

    return (
        <>
            {!editing && (
                <div className="flex items-center justify-between gap-2 w-full">
                    <div className="cursor-default whitespace-nowrap text-slate-700 font-light">
                        {name}
                    </div>
                    <button
                        disabled={loading}
                        onClick={() => {
                            setEditing(true);
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faPencilAlt}
                            className={cn(
                                "h-3 transition-colors text-slate-400",
                                {
                                    "hover:text-blue-400": !loading,
                                    "cursor-not-allowed": loading,
                                },
                            )}
                        />
                    </button>
                </div>
            )}
            {editing && (
                <div className="flex items-center justify-between gap-2 w-full">
                    <form
                        className="w-full"
                        autoComplete="off"
                        onSubmit={(e) => {
                            e.preventDefault();

                            if (updatedName === name) {
                                setEditing(false);
                                return;
                            }

                            onChange(updatedName);
                        }}
                    >
                        <TextInput
                            required
                            size="xs"
                            disabled={loading}
                            value={updatedName}
                            name="api-key-name"
                            block
                            placeholder="Name"
                            onChange={(val) => {
                                setUpdatedName(val);
                            }}
                        />
                    </form>
                    <div className="flex gap-2">
                        <button
                            disabled={loading}
                            onClick={() => {
                                if (updatedName === name) {
                                    setEditing(false);
                                    return;
                                }

                                onChange(updatedName);
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faFloppyDisk}
                                className={cn(
                                    "h-5 transition-colors text-slate-400",
                                    {
                                        "hover:text-emerald-600": !loading,
                                        "cursor-not-allowed": loading,
                                    },
                                )}
                            />
                        </button>
                        <button
                            disabled={loading}
                            onClick={() => {
                                setEditing(false);
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faTimes}
                                className={cn(
                                    "h-5 transition-colors text-slate-400",
                                    {
                                        "hover:text-red-600": !loading,
                                        "cursor-not-allowed": loading,
                                    },
                                )}
                            />
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}
